import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isPathCurrent } from './contentPages';
import { RailLinkProps, railLinkState } from './RailLink';

const ExternalMarker = () => (
  <span aria-hidden="true" className="tw-ml-auto tw-shrink-0 tw-pl-1 tw-text-xs tw-text-spa-tertiary">↗</span>
);

// The SPA's link renderer: pages with an SPA counterpart are router links; the rest are legacy
// full-reload pages (↗). rails-ujs isn't loaded in the SPA, so legacy Create actions can't be
// offered here and are skipped.
const SPARailLink = ({ children, ...props }: RailLinkProps) => {
  const { pathname } = useLocation();
  const { page } = props;

  if (page.method) return null;

  if (page.to) {
    const active = props.active ?? isPathCurrent(page.to, pathname, page.matchNested);
    const { className, current } = railLinkState({ ...props, active });
    return (
      <Link aria-current={current} className={className} to={page.to}>
        {children}
      </Link>
    );
  }

  const { className, current } = railLinkState(props);
  return (
    <a aria-current={current} className={className} href={page.href}>
      {children}
      <ExternalMarker />
    </a>
  );
};

export default SPARailLink;
